import React from 'react';
import { Page, useCareplusRouter } from '../../router/context';
import { useSpecialist } from '../../store/Specialist';
import { useUnits } from '../../store/Units';

import HeadTitle from '../../../../components/HeadTitle';
import { TypeCard } from '../../../../components/TypeCard';
import FooterWrapper from '../../../../components/FooterWrapper';

import { ReactComponent as LocationIcon } from '../../../../assets/location-rounded-blue.svg';
import { ReactComponent as CameraIcon } from '../../../../assets/telemedicine-rounded-camera.svg';

import * as S from './styles';
import { ATTENDANCE_TYPE, useAttendance } from '../../store/Attendance';
import TagInfo from '../../../../components/TagInfo';
import { IconWarningBlue } from '../../../../components/IconWarningBlue';
import { useSchedule } from '../../store/Schedule';
import { toast } from 'react-toastify';

export const ServiceType = (state: any) => {
  const { navigate, goBack } = useCareplusRouter();
  const { specialistSelected } = useSpecialist();
  const { selectedUnit } = useUnits();
  const [selectedAttendance, setSelectedAttendance] = React.useState(0);

  const { setSelectedAttendance: setAttendanceStore } = useAttendance();
  const { setService, scheduleBuild } = useSchedule();

  const [attendace, setAttendance] = React.useState({
    telemedicine: false,
    presential: false
  });

  // const getServices = async (props: { officeId: string; specialistId: number }) => {
  //   setLoading(true);

  //   const result = await fetchServicesBySpecialistAndOffice({
  //     channel: 'care-plus',
  //     ...props
  //   });

  //   setServices(result.data);

  //   setLoading(false);
  // };

  const checkAndStoreAttendances = (props: { presential: boolean; telemedicine: boolean }) => {
    if (!props.presential && !props.telemedicine) {
      toast.error('Agendamento indisponível para esse especialista.');
      goBack();
    }

    setAttendance(props);
  };

  React.useEffect(() => {
    if (selectedUnit) {
      const specialistUnitSelected = specialistSelected?.units?.find(unit => unit.id === selectedUnit);
      if (specialistUnitSelected?.attendance) checkAndStoreAttendances(specialistUnitSelected?.attendance);
    }
  }, []);

  const handleSubmit = () => {
    setAttendanceStore(selectedAttendance);

    const isTelemedicine = selectedAttendance === ATTENDANCE_TYPE.TELEMEDICINE;

    setService({ serviceId: isTelemedicine ? 8 : 7 });
    scheduleBuild();

    navigate(Page.PRODUCT_SLOTS, { ...state });
  };

  return (
    <S.Container>
      <S.Body>
        <HeadTitle title="Selecione o tipo de atendimento" goBack={goBack} />
        {state?.IS_FIRST_APPOINTMENT && (
          <div className="info-below-title">
            <TagInfo
              icon={<IconWarningBlue />}
              info="Sugerimos que a sua primeira consulta com um endocrinologista seja presencial."
            />
          </div>
        )}
        <>
          {attendace.presential && (
            <TypeCard
              checked={selectedAttendance === ATTENDANCE_TYPE.PRESENTIAL}
              onClick={() => setSelectedAttendance(ATTENDANCE_TYPE.PRESENTIAL)}
              title="Presencial"
              icon={<LocationIcon />}
            />
          )}
          {attendace.telemedicine && (
            <TypeCard
              checked={selectedAttendance === ATTENDANCE_TYPE.TELEMEDICINE}
              onClick={() => setSelectedAttendance(ATTENDANCE_TYPE.TELEMEDICINE)}
              title="Telemedicina"
              icon={<CameraIcon />}
            />
          )}
        </>
      </S.Body>
      <FooterWrapper>
        <S.ButtonWrapper>
          <S.Button
            title="Continuar"
            type="button"
            onClick={handleSubmit}
            disabled={selectedAttendance === ATTENDANCE_TYPE.DEFAULT}
          />
        </S.ButtonWrapper>
      </FooterWrapper>
    </S.Container>
  );
};
